export * from './People1GearIcon';
export * from './People1GearIcon16Light';
export * from './People1GearIcon16Regular';
export * from './People1GearIcon16Solid';
export * from './People1GearIcon20Light';
export * from './People1GearIcon20Regular';
export * from './People1GearIcon20Solid';
export * from './People1GearIcon24Regular';
export * from './People1GearIcon24Solid';
export * from './People1GearIcon32Regular';
export * from './People1GearIcon64Regular';
